import * as moment from 'moment';
import { FirebaseTripPing } from './firebase-trip-ping.model';
import { TripPingStatus } from './trip-ping-status';
import LatLngLiteral = google.maps.LatLngLiteral;

export class TripPingLight {

  public id: string;
  public deviceId: string;
  public vehicle: string;
  public latitude: number;
  public longitude: number;
  public createdAt: moment.Moment;
  public statuses: TripPingStatus[] = [];

  static fromFirebase(firebasePing: FirebaseTripPing): TripPingLight {
    if (!firebasePing) {
      return null;
    }

    const ping = new TripPingLight();

    ping.id        = firebasePing.id;
    ping.deviceId  = firebasePing.deviceId;
    ping.vehicle   = firebasePing.vehicle;
    ping.latitude  = firebasePing.latitude;
    ping.longitude = firebasePing.longitude;
    ping.createdAt = firebasePing.createdAt;
    ping.statuses  = firebasePing.statuses || [];

    return ping;
  }

  static fromDto(p): TripPingLight {
    if (!p) {
      return null;
    }

    const ping = new TripPingLight();

    ping.id        = p.id;
    ping.deviceId  = p.device_id;
    ping.vehicle   = p.vehicle;
    ping.latitude  = p.latitude;
    ping.longitude = p.longitude;
    ping.createdAt = p.created_at ? moment(p.created_at) : null;
    ping.statuses  = p.statuses || [];

    return ping;
  }

  toLatLntLiteral(): LatLngLiteral {
    return { lat: this.latitude, lng: this.longitude };
  }
}
